module.exports = __webpack_public_path__ + "media/images/admin2/AdminSpotsShow__video__overlay-178dabe290da76de1ad9be3e2c4e68c2.svg";